export default "../media/up_arrow.81f22f313cb8593d76ae1f0ef17a0a55.svg";